/** Pulsar wordmark — used in topbars + auth screens.
 *
 * Version chip is intentionally removed: end users never see internal
 * version numbers. Add a separate <Version /> primitive if we ever
 * want that in an admin-only place.
 */
import { cn } from '@/lib/cn'

interface LogoProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const sizes = {
  sm: { mark: 'w-5 h-5 text-base',  text: 'text-sm' },
  md: { mark: 'w-6 h-6 text-lg',    text: 'text-base' },
  lg: { mark: 'w-10 h-10 text-2xl', text: 'text-2xl' },
}

export function Logo({ size = 'md', className }: LogoProps) {
  const s = sizes[size]
  return (
    <div className={cn('inline-flex items-center gap-2', className)}>
      <div
        className={cn(
          'grid place-items-center bg-fire-faint rounded',
          s.mark,
        )}
        aria-hidden
      >
        <span className="text-fire leading-none">▲</span>
      </div>
      <span className={cn('font-semibold tracking-wide', s.text)}>
        PULSAR
      </span>
    </div>
  )
}
